<p>network-share-details works!</p>
